import Typewriter from "typewriter-effect";
import { PHRASES } from "../../constants/mascotPhrases";
import chefLogo from "../../assets/images/chef-logo.png";
export function BrandSection() {
  return (
    <div className="w-full md:flex-[6] flex items-center justify-center flex-col gap-4 md:gap-6 bg-gradient-to-br from-gray-50 to-gray-100 py-8 md:py-0 px-4 md:px-8 min-h-[40vh] md:min-h-screen">
      <h1 className="text-4xl md:text-6xl font-bold text-gray-900">
        Chef Prepper
      </h1>
      <img
        src={chefLogo}
        alt="Little Chef with hat"
        className="w-32 h-32 md:w-64 md:h-64 object-contain"
      />
      <div className="text-lg md:text-xl text-gray-600 font-medium min-h-[32px] px-6 text-center">
        <Typewriter
          onInit={(typewriter) => {
            typewriter.pauseFor(2500).deleteAll().start();
          }}
          options={{ autoStart: true, loop: true, strings: PHRASES }}
        />
      </div>
    </div>
  );
}
